require(
      "!../../node_modules/gatsby-module-loader/patch.js"
    );
    module.exports = function(cb) { return require.ensure([], function(_, error) {
        if (error) {
          console.log('bundle loading error', error)
          cb(true)
        } else {
          cb(null, function() { return require("!!../../node_modules/json-loader/index.js!./package-unpublished-codinglawyer-reason-react-boilerplate.json") })
        }
      }, "path---package-unpublished-codinglawyer-reason-react-boilerplate");
     }
    


//////////////////
// WEBPACK FOOTER
// ./~/gatsby-module-loader?name=path---package-unpublished-codinglawyer-reason-react-boilerplate!./.cache/json/package-unpublished-codinglawyer-reason-react-boilerplate.json
// module id = 934
// module chunks = 231608221292675